import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { useInView, reveal } from './motion';
import { BOOK_QUOTE } from '../../data/testimonials';
import { useT, useLang } from '../../i18n/LanguageContext';

const getStats = (t) => [
  { v: '40', l: t('home.socialProof.statCardsLabel') },
  { v: '5', l: t('home.socialProof.statFamiliesLabel') },
  { v: '∞', l: t('home.socialProof.statCombinationsLabel') },
  { v: 'AI', l: t('home.socialProof.statMentorLabel') },
];

export default function SocialProof() {
  const theme = useTheme();
  const { ref, visible } = useInView();
  const t = useT();
  const { lang } = useLang();
  const stats = getStats(t);
  const quote = BOOK_QUOTE[lang] || BOOK_QUOTE.it;

  return (
    <Box sx={{ bgcolor: '#fff', py: theme.home.sectionPy }}>
      <Box ref={ref} sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 } }}>
        {/* stats band */}
        <Box sx={{
          display: 'grid', gridTemplateColumns: { xs: 'repeat(2,1fr)', md: 'repeat(4,1fr)' }, gap: 4,
          pb: { xs: 6, md: 8 },
          borderBottom: `1px solid ${theme.home.paperDeep}`,
        }}>
          {stats.map((s, i) => (
            <Box key={s.l} sx={{ textAlign: 'center', ...reveal(visible, i * 0.08) }}>
              <Typography sx={{ fontFamily: theme.home.display, fontWeight: 900, fontSize: { xs: '2.6rem', md: '3.4rem' }, color: theme.home.cyanText, lineHeight: 1 }}>
                {s.v}
              </Typography>
              <Typography sx={{ mt: 1, color: theme.home.inkMuted, fontWeight: 600, letterSpacing: '0.02em' }}>{s.l}</Typography>
            </Box>
          ))}
        </Box>

        {/* book pull-quote — a real line from the manuscript's own introduction,
            not a user testimonial (the product has none to show yet) */}
        <Box sx={{ mt: { xs: 6, md: 8 }, maxWidth: 760, mx: 'auto', textAlign: 'center', ...reveal(visible, 0.15) }}>
          <FormatQuoteIcon sx={{ color: theme.home.coralText, fontSize: 40, transform: 'scaleX(-1)' }} />
          <Typography sx={{ fontFamily: theme.home.display, fontStyle: 'italic', fontSize: { xs: '1.4rem', md: '1.75rem' }, color: theme.home.ink, lineHeight: 1.4, mt: 1 }}>
            “{quote.quote}”
          </Typography>
          <Typography sx={{ mt: 2.5, fontWeight: 700, color: theme.home.inkMuted, fontSize: '0.85rem' }}>
            {quote.source}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
